import { FC, MouseEventHandler, useState } from "react";
import Modal from "../Modal";
import { QuestionType } from "../../common/questionType";
import { ApplicationState, AppThunkDispatch } from "../../store";
import { connect, ConnectedProps } from "react-redux";
import Suspense from "../suspense/Suspense";
import * as QuestionManagementHelper from "../../common/questionManagementHelper";
import { QuestionManagementEntry } from "../../store/questionManagement";
import { questionManagementActionCreators } from "../../actions/questionManagementActions";

interface AddQuestionManagementEntryModalProps extends ConnectedProps<typeof connector> {
    isVisible: boolean;
    questionText: string;
    questionType: QuestionType | null;
    onClose: () => void;
}

const AddQuestionManagementEntryModal: FC<AddQuestionManagementEntryModalProps> = (props) => {
    const [isSubmitted, SetIsSubmitted] = useState(false);
    const [validationError, SetValidationError] = useState<string | null>(null);
    
    const { CreateQuestionManagementEntry } = props;
    const { questionManagementState } = props;
    
    const HandleCancelButtonClick: MouseEventHandler<HTMLButtonElement> = () => {
        props.onClose();
    }
    
    const HandleAddButtonClick: MouseEventHandler<HTMLButtonElement> = async () => {
        SetIsSubmitted(true);
        
        if (props.questionType !== null && questionManagementState.data) {

            if (QuestionManagementHelper.QuestionManagementItemAlreadyExists(questionManagementState.data, props.questionText)) {

                 SetValidationError("This question is already in either the RAQ or Knowledge Centers list.");
            }
            else {
                
                 CreateQuestionManagementEntry({ questionText: props.questionText, questionType: props.questionType });
            }
        }
        else {
            SetValidationError("An error occurred. Please try again.");
        }
    }
    
    const HandleCloseButtonClick: MouseEventHandler<HTMLButtonElement> = () => {
        props.onClose();
        SetIsSubmitted(false);
        SetValidationError(null);
    }
    
    const GetMessage = () => {
        let message = "";

        if (props.questionType === QuestionType.Raq) {
            message = "Are you sure you want to add this question to the RAQ section?";
        }
        else if (props.questionType === QuestionType.Faq) {
            message = "Are you sure you want to add this question to the Knowledge Centers section?";
        }

        return message;
    }
    
    const GetSubmittedMessage = () => {
        return "The question has been successfully added";
    }
    
    const GetErrorMessage = () => {
        let message = "An unknown error occurred.";

        if (props.questionType === QuestionType.Raq) {
            message = "An error occurred while adding this question to the RAQ section.";
        }
        else if (props.questionType === QuestionType.Faq) {
            message = "An error occurred while adding this question to the Knowledge Centers section.";
        }

        return message;
    }
    
    return (
        <Modal
            isVisible={props.isVisible}
            modalStyle="popup-small"
        >
            <Suspense isLoading={questionManagementState.isLoading}>
                {!isSubmitted ? (
                    <>
                        <h2>{GetMessage()}</h2>

                        <div className="drawer-split">
                            <button className="cancel" onClick={HandleCancelButtonClick}>
                                <i className="fa fa-times" />  Cancel
                            </button>
                            <button className="save" onClick={HandleAddButtonClick}>
                                <i className="fa fa-plus"/>  Add
                            </button>
                        </div>
                    </>
                ) : (
                    <>
                        <h2>{validationError !== null ? validationError : (questionManagementState.error ? GetErrorMessage() : GetSubmittedMessage())}</h2>
                        
                        <div className="drawer-split">
                            <button className="cancel" onClick={HandleCloseButtonClick}>
                                <i className="fa fa-times" />  Close
                            </button>
                        </div>
                    </>
                )}
            </Suspense>
        </Modal>
    );
}

const MapStateToProps = (applicationState: ApplicationState) => {
    const questionManagementState = applicationState.questionManagement;
    
    return { questionManagementState };
}

const MapDispatchToProps = (dispatch: AppThunkDispatch) => ({
    CreateQuestionManagementEntry: (questionManagementEntry: Omit<QuestionManagementEntry, 'id'>) => {
        dispatch(questionManagementActionCreators.createQuestionManagementEntry(questionManagementEntry));
    }
});

const connector = connect(MapStateToProps, MapDispatchToProps);
export default connector(AddQuestionManagementEntryModal);